import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'
var moment = require('moment');

const ListaTP = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoProducto" id="miLista1" value={permiteUpdate?argsDocum.tipoProducto:idLista.tipoProducto} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Producto</option>
        <option>Servicio</option>
        <option>Programa</option>
      </select>
    </div>
  )
};
const ListaTO = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoOrden" id="miLista3" value={permiteUpdate?argsDocum.tipoOrden:idLista.tipoOrden} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Laboratorio</option>
        <option>In house</option>
        <option>Despacho</option>
        <option>Otros</option>
      </select>
    </div>
  )
};
const ListaEs = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="estado" id="miLista3" value={permiteUpdate?argsDocum.estado:idLista.estado} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Activo</option>
        <option>Inactivo</option>
      </select>
    </div>
  )
};
const DetalleEmpNivel1 = props => {
  return (
    <option dato1={props.elemento.abrevUnidad} value={props.elemento.descrUnidad}>{props.elemento.descrUnidad}</option>
  )
};

const ListaUni = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrUnidad" id="miLista8" value={permiteUpdate?argsDocum.descrUnidad:idLista.descrUnidad?idLista.descrUnidad:''} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleEmpNivel2 = props => {
  return (
    <option value={props.elemento.descrLubricante}>{props.elemento.descrLubricante}</option>
  )
};

const ListaLub = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrLubricante" id="miLista2" value={permiteUpdate?argsDocum.descrLubricante:idLista.descrLubricante?idLista.descrLubricante:'NINGUNO'} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option value="">NINGUNO</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const ListaMon = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="monedaCosto" id="miLista55" value={permiteUpdate?argsDocum.monedaCosto:idLista.monedaCosto?idLista.monedaCosto:'Seleccionar...'} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Pesos</option>
        <option>Dolares</option>
        <option>Euros</option>
      </select>
    </div>
  )
};

class VerProducto2 extends React.Component {
  state={
    argsDocum: {file: "", file1: "",
      tipoProducto: this.props.idLista.tipoProducto,
      tipoOrden: this.props.idLista.tipoOrden,
      descrProducto: this.props.idLista.descrProducto,
      descrCorta: this.props.idLista.descrCorta?this.props.idLista.descrCorta:'',
      codigo: this.props.idLista.codigo?this.props.idLista.codigo:'',
      marca: this.props.idLista.marca?this.props.idLista.marca:'',
      ficha: this.props.idLista.ficha?this.props.idLista.ficha:'',
      ficha2: this.props.idLista.ficha2?this.props.idLista.ficha2:'',
      descrUnidad: this.props.idLista.descrUnidad?this.props.idLista.descrUnidad:'',
      descrLubricante: this.props.idLista.descrLubricante?this.props.idLista.descrLubricante:'NINGUNO',
      precio: this.props.idLista.precio?this.props.idLista.precio:0,
      costo: this.props.idLista.costo?this.props.idLista.costo:0,
      margen: this.props.idLista.margen?this.props.idLista.margen:0,
      monedaCosto: this.props.idLista.monedaCosto?this.props.idLista.monedaCosto:'',
      vigenteHasta: this.props.idLista.vigenteHasta?this.props.idLista.vigenteHasta:this.props.fechaHasta,
      porcIVA: this.props.idLista.porcIVA?this.props.idLista.porcIVA:0,
      precioDolar: this.props.idLista.precioDolar?this.props.idLista.precioDolar:0,
      porcImpto: this.props.idLista.porcImpto?this.props.idLista.porcImpto:0,
      comisionRango1: this.props.idLista.comisionRango1?this.props.idLista.comisionRango1:0,
      comisionRango2: this.props.idLista.comisionRango2?this.props.idLista.comisionRango2:0,
      comisionRango3: this.props.idLista.comisionRango3?this.props.idLista.comisionRango3:0,
      comisionExt: this.props.idLista.comisionExt?this.props.idLista.comisionExt:0,
      estado: this.props.idLista.estado?this.props.idLista.estado:'Activo',
      _id: this.props.idLista._id
    },
    confirmaAct: false,
    open: false
  }

  // handleChange = (ev) => {
  //   if (this.props.permiteUpdate){
  //     this.setState({confirmaAct: false})
  //     if(ev.target.name !== "abrevMetodo"){
  //       const argsDocum = this.state.argsDocum
  //       if(ev.target.name === "tipoMetodo"){
  //         let miLista = document.getElementById("miLista");
  //         argsDocum['tipoMetodo'] = miLista.options[miLista.selectedIndex].text
  //       }else{
  //         argsDocum[ev.target.name] = ev.target.value
  //       }
  //       this.setState({argsDocum});
  //     } 
  //   }
  // }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      let file = "", ficha = "", file1 = "", ficha2 = ""
      if(ev.target.name==='file' || ev.target.name==='file1'){
        if(ev.target.name==='file'){
          file = ev.target.files[0]
          ficha = ev.target.files[0].name
          argsDocum['ficha'] = ficha
          argsDocum['file'] = file      
        }
        if(ev.target.name==='file1'){
          file1 = ev.target.files[0]
          ficha2 = ev.target.files[0].name
          argsDocum['ficha2'] = ficha2
          argsDocum['file1'] = file1      
        }
      }else{
        if(ev.target.name === "tipoLub"){
          let miLista = document.getElementById("miLista1");
          argsDocum['tipoLub'] = miLista.options[miLista.selectedIndex].text
        }else{
          if(ev.target.name === "monedaCosto"){
            let miLista = document.getElementById("miLista55");
            argsDocum['monedaCosto'] = miLista.options[miLista.selectedIndex].text
          }else{
            argsDocum[ev.target.name] = ev.target.value
          }
        }
      }
      this.setState({argsDocum});
    }
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){ 
    const {argsDocum, confirmaAct, open} = this.state;
      const a251025 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251025" );
      const a251030 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251030" );

    let descrProductoAnt = this.props.idLista.descrProducto
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let fechaHasta = new Date(argsDocum.vigenteHasta)
    fechaHasta = (fechaHasta.getFullYear()) + '-' + ((fechaHasta.getMonth()+1)<10?'0'+(fechaHasta.getMonth()+1):(fechaHasta.getMonth()+1)) + '-' + (fechaHasta.getUTCDate()<10?'0'+fechaHasta.getUTCDate():fechaHasta.getUTCDate())

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Producto
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum, descrProductoAnt, this.props.autorizacUA):()=>{}}>
          <div className="ui seven column stackable grid">
            <div className="row container">
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '12%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de producto</label>
                    <ListaTP styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '12%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de orden</label>
                    <ListaTO styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '15%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Marca</label>
                    <Form.Input autoComplete="off" name="marca" id="marca" value={this.props.permiteUpdate?argsDocum.marca:this.props.idLista.marca} onChange={this.handleChange} placeholder='Marca' icon={!this.props.errors?null: _find(this.props.errors, {path:'marca'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '31%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrProducto" id="descrProducto" value={this.props.permiteUpdate?argsDocum.descrProducto:this.props.idLista.descrProducto} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors?null: _find(this.props.errors, {path:'descrProducto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código</label>
                    <Form.Input autoComplete="off" name="codigo" id="codigo" value={this.props.permiteUpdate?argsDocum.codigo:this.props.idLista.codigo} onChange={this.handleChange} placeholder='Código' icon={!this.props.errors?null: _find(this.props.errors, {path:'codigo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || (a251025!==-1 && a251030===-1)) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Costo</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="costo" id="costo" value={this.props.permiteUpdate?argsDocum.costo:this.props.idLista.costo?this.props.idLista.costo:0} onChange={this.handleChange} placeholder='Costo' icon={!this.props.errors?null: _find(this.props.errors, {path:'costo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || (a251025!==-1 && a251030===-1)) &&
                <div className="column" style={{width: '10%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Moneda costo</label>
                    <ListaMon styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field> 
                </div>
              }
            </div>
            <div className="row container">
            {(localStorage.getItem('userLogin')==="slcm@slcm.com" || (a251025!==-1 && a251030===-1)) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Precio Und en $</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="precio" id="precio" value={this.props.permiteUpdate?argsDocum.precio:this.props.idLista.precio?this.props.idLista.precio:0} onChange={this.handleChange} placeholder='Precio und en $' icon={!this.props.errors?null: _find(this.props.errors, {path:'precio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || (a251025!==-1 && a251030===-1)) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Precio Und en $US</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="precioDolar" id="precioDolar" value={this.props.permiteUpdate?argsDocum.precioDolar:this.props.idLista.precioDolar?this.props.idLista.precioDolar:0} onChange={this.handleChange} placeholder='Precio und en $US' icon={!this.props.errors?null: _find(this.props.errors, {path:'precioDolar'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || (a251025!==-1 && a251030===-1)) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={{color: 'black', fontSize: 16}}>Vigencia de precio</label>
                    <input style={this.props.styles.input} type='date' name="vigenteHasta" id="vigenteHasta" value={fechaHasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Unidad</label>
                    <ListaUni list={this.props.listUni} styles={this.props.styles} idLista={this.props.idLista}
                    argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>                
                  </Form.Field>    
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '8%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>% IVA</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="porcIVA" id="porcIVA" value={this.props.permiteUpdate?argsDocum.porcIVA:this.props.idLista.porcIVA?this.props.idLista.porcIVA:0} onChange={this.handleChange} placeholder='% IVA' icon={!this.props.errors?null: _find(this.props.errors, {path:'porcIVA'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '8%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>% ITBMS</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="porcImpto" id="porcImpto" value={this.props.permiteUpdate?argsDocum.porcImpto:this.props.idLista.porcImpto?this.props.idLista.porcImpto:0} onChange={this.handleChange} placeholder='% ITBMS' icon={!this.props.errors?null: _find(this.props.errors, {path:'porcImpto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '34%'}}>                
                  <Form.Field>
                    <label style={this.props.styles.label}>Lubricante asociado</label>
                    <ListaLub list={this.props.listLub} styles={this.props.styles} idLista={this.props.idLista}
                    argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>                
                  </Form.Field>    
                </div>      
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Estado</label>
                    <ListaEs styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
              }
            </div>
            <div className="row container">
            {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Comisión rango 1</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="comisionRango1" id="comisionRango1" value={this.props.permiteUpdate?argsDocum.comisionRango1:this.props.idLista.comisionRango1?this.props.idLista.comisionRango1:0} onChange={this.handleChange} placeholder='comisión rango 1' icon={!this.props.errors?null: _find(this.props.errors, {path:'comisionRango1'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Comisión rango 2</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="comisionRango2" id="comisionRango2" value={this.props.permiteUpdate?argsDocum.comisionRango2:this.props.idLista.comisionRango2?this.props.idLista.comisionRango2:0} onChange={this.handleChange} placeholder='comisión rango 2' icon={!this.props.errors?null: _find(this.props.errors, {path:'comisionRango2'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Comisión rango 3</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="comisionRango3" id="comisionRango3" value={this.props.permiteUpdate?argsDocum.comisionRango3:this.props.idLista.comisionRango3?this.props.idLista.comisionRango3:0} onChange={this.handleChange} placeholder='comisión rango 3' icon={!this.props.errors?null: _find(this.props.errors, {path:'comisionRango3'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Comisión externos</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="comisionExt" id="comisionExt" value={this.props.permiteUpdate?argsDocum.comisionExt:this.props.idLista.comisionExt?this.props.idLista.comisionExt:0} onChange={this.handleChange} placeholder='comisión externos' icon={!this.props.errors?null: _find(this.props.errors, {path:'comisionExt'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {(localStorage.getItem('userLogin')==="slcm@slcm.com" || a251030===-1) &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>% Utilidad</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="margen" id="margen" value={this.props.permiteUpdate?argsDocum.margen:this.props.idLista.margen?this.props.idLista.margen:0} onChange={this.handleChange} placeholder='% Utilidad' icon={!this.props.errors?null: _find(this.props.errors, {path:'margen'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />}/>
                  </Form.Field> 
                </div>
              }
              {/* {a251030===-1 && */}
                <div className="column" style={{width: '31%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción corta</label>
                    <Form.Input autoComplete="off" name="descrCorta" id="descrCorta" value={this.props.permiteUpdate?argsDocum.descrCorta:this.props.idLista.descrCorta?this.props.idLista.descrCorta:''} onChange={this.handleChange} placeholder='Descripción corta' icon={!this.props.errors?null: _find(this.props.errors, {path:'descrCorta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              {/* } */}
            </div>
          </div>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" width="50%">
                <Form.Field>
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Seleccionar archivo de ficha técnica... &nbsp;&nbsp;(Actual: {this.props.idLista.ficha})
                  
                  </label>
                  <input id="file" name="file" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                </Form.Field>  
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Seleccionar archivo de ficha de seguridad...&nbsp;&nbsp;(Actual: {this.props.idLista.ficha2})
                  </label>
                  <input id="file1" name="file1" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                </Form.Field>  
              </div>
            </div>
          </div>

            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
        </Form>
      </div>
    </div>
    )
  }
}

export default VerProducto2
